export const stringToOption = (str) => ({ label: str, value: str });
export const strListToOptionList = (list) => list.map((s) => stringToOption(s));
